function SendRight() {
  return (
    <div
      style={{
        borderRadius: '9px',
        background: '#06F',
        width: '32px',
        height: '32px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <svg
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='send-right'>
          <path
            id='send-right_2'
            d='M20.4031 9.629L8.99613 2.80701C7.46713 1.89001 5.60011 2.132 4.35111 3.401C3.10911 4.664 2.90197 6.52401 3.83597 8.02801L6.30301 12L3.83597 15.972C2.90097 17.476 3.10811 19.336 4.35111 20.599C5.09411 21.354 6.05495 21.745 7.03495 21.745C7.70095 21.745 8.37713 21.564 8.99613 21.193L20.4031 14.371C21.2471 13.867 21.75 12.98 21.75 12C21.75 11.02 21.2471 10.133 20.4031 9.629ZM19.6341 13.084L8.22708 19.906C7.08808 20.586 6.00293 20.139 5.42093 19.547C4.84493 18.961 4.41714 17.88 5.11014 16.763L7.60306 12.749H13C13.414 12.749 13.75 12.413 13.75 11.999C13.75 11.585 13.414 11.249 13 11.249H7.60306L5.11014 7.23498C4.41714 6.11798 4.84393 5.03699 5.42093 4.45099C5.79493 4.07099 6.37593 3.75 7.04593 3.75C7.41893 3.75 7.81908 3.84899 8.22708 4.09299L19.6341 10.915C20.0201 11.146 20.25 11.551 20.25 11.999C20.25 12.447 20.0201 12.853 19.6341 13.084Z'
            fill='white'
          />
        </g>
      </svg>
    </div>
  );
}

export default SendRight;
